export default {
  apiKey: "AIzaSyDVHTp5dsr6WNz1VLIqyAhCdNaMtU3PVcw",
  authDomain: "eng-jobfair.firebaseapp.com",
  databaseURL: "https://eng-jobfair.firebaseio.com",
  projectId: "eng-jobfair",
  storageBucket: "eng-jobfair.appspot.com",
  messagingSenderId: "94972867815",
  appId: "1:94972867815:web:5ca86f7e798e0bcc29de42",
  measurementId: "G-RZ8X22X5C0"
};